/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Still_Maple_Cat_CurlInputs */

const en_still_maple_cat_curl = /** @type {(inputs: Still_Maple_Cat_CurlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pending`)
};

const de_still_maple_cat_curl = /** @type {(inputs: Still_Maple_Cat_CurlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausstehend`)
};

/**
* | output |
* | --- |
* | "Pending" |
*
* @param {Still_Maple_Cat_CurlInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const still_maple_cat_curl = /** @type {((inputs?: Still_Maple_Cat_CurlInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Still_Maple_Cat_CurlInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_still_maple_cat_curl(inputs)
	return de_still_maple_cat_curl(inputs)
});